// export this package's api
import Align from './Align';
export default Align;


//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/node_modules/rc-align/es/index.js
// module id = null
// module chunks = 